module.exports = __webpack_public_path__ + "static/media/feeling_proud.fab079d1.svg";